import { notification } from "antd";
import Api from "../../api";
import API_URL from "../../api/url";
import { setFaqsCount, setUsersCount, setConstentRequestLog, setHipDataRequestLog, setHipConstentGrantLog, setHipAuthConfirmLog, setAbdmHipLog, sethiuConsentArtifactRequested, setCconsentGrantLogs, setConsentArtifactDetails, setHelathInformationRequested, setDataRequestSentLogs, setpatientAbhaCardsLogs, setDashboardCounts, setHiuDashboardCounts, setDataSharedHip, setHiuDataRequest, setDataPendingLogs, setUserInisited, setDashboardLinked } from "../Slices/dashboardSlice";

export const fetchUserCountApi = (data) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.DASHBOARD_USER_COUNT, data);
    dispatch(setUsersCount(res.data?.Data));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchFaqCountApi = (data) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.DASHBOARD_FAQ_COUNT, data);
    dispatch(setFaqsCount(res.data?.Data));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};

export const fetchHIPAuthConfirmApi = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hip/list/auth-confirm-logs", { params: params });
    dispatch(setHipAuthConfirmLog(res.data.result, res.data.dataLength));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchHIPConsentGrantLogApi =
  (params, limit, page) => async (dispatch) => {
    try {
      const res = await Api.get("hip/list/consent-grant-logs", {
        params: { ...params, limit: limit, page: page },
      });
      dispatch(
        setHipConstentGrantLog({
          list: res.data.result,
          dataLength: res.data.dataLength,
        })
      );
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const fetchHIPDataRequestsLogApi = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hip/list/data-request-rec-logs", {
      params, // axios will send this as query params
    });
    dispatch(
      setHipDataRequestLog({
        list: res.data.result,
        dataLength: res.data?.dataLength,
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};

export const fetchHIPLinkedCareContextListApi =
  (userInput) => async (dispatch) => {
    try {
      const { page, limit, filter } = userInput;

      const res = await Api.post("hip/linked/care-contexts", {
        page,
        limit,
        filter,
      });
      // console.log(res, "===+");

      dispatch(
        setHipDataRequestLog({
          list: res.data.result,
          dataLength: res.data?.dataLength,
        })
      );
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const fetchuserInisitedApi =
  (DataType, limit, page) => async (dispatch) => {
    try {
      const res = await Api.get("hip/list/link-record-api-request-logs", {
        params: { ...DataType, limit: limit, page: page },
      });
      dispatch(setUserInisited(res.data?.result));
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const fetchAbdmHipApi = (DataType, limit, page) => async (dispatch) => {
  try {
    const res = await Api.get("hip/list/abdm-hip-logs", {
      params: { ...DataType, limit: limit, page: page },
    });
    dispatch(setAbdmHipLog(res.data));
    // console.log(res)
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchConsentRequestsLogApi = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hiu/list/consent-requests-logs", {
      params: params,
    });
    dispatch(setConstentRequestLog(res.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchhiuConsentArtifactRequested =
  (params) => async (dispatch) => {
    try {
      const res = await Api.get("hiu/list/consent-requests-logs", {
        params: params,
      });
      dispatch(
        sethiuConsentArtifactRequested({
          list: res.data.result,
          dataLength: res.data.dataLength,
        })
      );
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const fetchCconsentGrantLogs = (data) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/consent-logs", data);
    // console.log("5645", res);

    dispatch(
      setCconsentGrantLogs({
        list: res.data.result,
        dataLength: res.data.dataLength,
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchconsentLogs = (data) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/consent-logs", data);
    // console.log(res, "()()()");

    dispatch(
      setCconsentGrantLogs({
        list: res.data.result,
        dataLength: res.data.dataLength,
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
// export const fetchConsentArtifactDetails = (params) => async (dispatch) => {
//   try {
//     const res = await Api.get("hiu/list/fetch-consent-details-logs", {
//       params: params
//     });
//     dispatch(
//       setConsentArtifactDetails({
//         list: res.data.result,
//         dataLength: res.data.dataLength
//       })
//     );
//     return res;
//   } catch (error) {
//     notification["error"]({
//       message: error.response?.data?.message || error.message
//     });
//     return error;
//   }
// };
export const fetchConsentArtifactDetails = (body) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/list/fetch-consent-details-logs", body);

    dispatch(
      setConsentArtifactDetails({
        list: res.data.result || [],
        dataLength: res.data.dataLength || 0,
      })
    );

    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};

export const fetchHelathInformationRequested = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hiu/list/data-request-sent-logs", {
      params: params,
    });
    dispatch(setHelathInformationRequested(res.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchDataRequestSentLogs = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hiu/list/data-request-sent-logs", {
      params: params,
    });
    dispatch(
      setDataRequestSentLogs({
        list: res.data.result,
        dataLength: res.data.dataLength,
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchDataPendingLogs = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hiu/list/data-request-pending", {
      params: params,
    });
    dispatch(
      setDataPendingLogs({
        list: res.data.result,
        dataLength: res.data.dataLength,
      })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchgetCardsLogsSearch = (payload) => async (dispatch) => {
  try {
    const res = await Api.post("admin/getCardLogs", payload);
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
// export const fetchgetCardsLogsSearch = (params) => async (dispatch) => {
//     try {
//         const res = await Api.post("abha/searchByHealthId", {params:params, customToken: true });
//         return res;
//     } catch (error) {
//         return error
//     }
// };
export const doConsentRequestInit = (data) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/consent-requests-init", data);
    notification["success"]({
      message: "Consent Requests successfully!",
    });
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};

export const hiuConsentRequestInit = (data) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/initiate-consent-request", data);
    notification["success"]({
      message: "Consent Requests successfully!",
    });
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};

export const constentArtifactDetailsFetch =
  (data, navigate) => async (dispatch) => {
    try {
      const res = await Api.post("/hiu/fetch-consent-artifact", data);
      notification["success"]({
        message: "Fetch HIP successfully!",
      });
      navigate("/hiu-consent-artifact-details");
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const getDashboardCount = (data, UserId, RoleId) => async (dispatch) => {
  try {
    const res = await Api.get("/admin/getDashboardCounts", {
      data: data,
      params: UserId,
      RoleId,
    });
    dispatch(setDashboardCounts(res?.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const getDashboardLinkedCount =
  (data, UserId, RoleId) => async (dispatch) => {
    try {
      const res = await Api.post("/admin/patient/report/linked", {
        data: data,
        params: UserId,
        RoleId,
      });
      dispatch(setDashboardLinked(res?.data?.result));
      return res;
    } catch (error) {
      notification["error"]({
        message: error.response?.data?.message || error.message,
      });
      return error;
    }
  };
export const getHiuDashboardCount = (data, UserId) => async (dispatch) => {
  try {
    const res = await Api.get("/admin/hiu/getDashboardCounts", {
      data: data,
      params: UserId,
    });
    dispatch(setHiuDashboardCounts(res?.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const patientAbhaCardsLogs = (params) => async (dispatch) => {
  try {
    const res = await Api.post("abha/patientAbhaCardsLogs");
    dispatch(setpatientAbhaCardsLogs(res.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchDataSharedHipApi = (params) => async (dispatch) => {
  try {
    const res = await Api.get("hip/list/abdm-hip-logs", { params: params });
    dispatch(setDataSharedHip(res.data?.result));
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
export const fetchHiuDataReceive = (body) => async (dispatch) => {
  try {
    const res = await Api.post("hiu/list/data-receive-log", body);

    dispatch(
      setHiuDataRequest({
        list: res.data.result || [],
        dataLength: res.data.dataLength || 0,
      })
    );

    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message,
    });
    return error;
  }
};
